import { Heading, Inline, Text, Button, Stack, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { X as CloseIcon } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
  header: css`
    justify-content: space-between;
    margin-bottom: 16px;
  `,
  closeButton: css`
    border-width: 0;
    margin-bottom: auto;
    padding: 0;
  `
};
const SeatMapHeader = _ref => {
  let {
    from,
    to,
    currentSegmentIndex,
    totalSegmentsCount,
    currentSegmentData,
    handleCloseButton,
    isSummaryShowing
  } = _ref;
  const {
    t
  } = useTranslation();
  const SeatMapHeading = t('Product.SeatMap.Header.Label');
  const segmentDescriptionText = currentSegmentData && currentSegmentIndex ? t('Seating.Segments.Details.Description', currentSegmentIndex, totalSegmentsCount, currentSegmentData.from.iata, currentSegmentData.to.iata) : '';
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 0,
    children: [/*#__PURE__*/_jsxs(Inline, {
      className: styles.header,
      "data-testid": "seatMap-header",
      children: [/*#__PURE__*/_jsx(Heading, {
        "data-testid": "seatMap-heading",
        level: 2,
        children: SeatMapHeading
      }), /*#__PURE__*/_jsx(Button, {
        "aria-label": t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
        className: styles.closeButton,
        "data-testid": "seatMap-closeIcon-button",
        onClick: handleCloseButton,
        type: "button",
        children: /*#__PURE__*/_jsx(CloseIcon, {
          size: 25
        })
      })]
    }), !isSummaryShowing && /*#__PURE__*/_jsxs(Inline, {
      className: styles.header,
      children: [/*#__PURE__*/_jsxs(Text, {
        "data-testid": "seatMap-segment-description",
        variant: textVariants._16_BOLD,
        children: [from, " \u2013 ", to]
      }), /*#__PURE__*/_jsx(Text, {
        "data-testid": "seatMap-segments-text",
        variant: textVariants._14,
        children: segmentDescriptionText
      })]
    })]
  });
};
export default SeatMapHeader;
//# sourceMappingURL=SeatMapHeader.js.map